import { AdjustersLayout as MobileAdjusters } from '@/components/mo/Adjusters';
import { AdjustersLayout as PcAdjusters } from '@/components/pc/Adjusters';
import { useIsMobile } from '@/hooks/useIsMobile';
import { Spin } from 'antd';
import styled from 'styled-components';

const AdjusterIntroPage = () => {
  const isMobile = useIsMobile();

  if (isMobile === null) {
    return (
      <SpinnerWrapper>
        <Spin size="large" />
      </SpinnerWrapper>
    );
  }

  return isMobile ? <MobileAdjusters /> : <PcAdjusters />;
};

export default AdjusterIntroPage;

const SpinnerWrapper = styled.div`
  display: flex;
  height: 100vh;
  align-items: center;
  justify-content: center;
`;
